module.exports = __webpack_public_path__ + "files/decc436ab86983151d0ca1aad23608b1.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/droidserif-italic-webfont.woff
 ** module id = 904
 ** module chunks = 0
 **/